<template>
  <div class="main-wrapper">
    <div class="tax-modes">
      <p class="necessary-bold">
        <span :class="!validTaxMode() ? 'unvalid-field' : 'valid-field'"
          >➤</span
        >
        Режим налогообложения:
      </p>
      <div class="main-checkboxes" v-for="item in checkboxes" :key="item.ID">
        <label>
          <input
            type="checkbox"
            v-model="item.CHECKED"
            @click="onCheck(item.ID)"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('TAX_MODE_FULL') != -1
            "
          />
          {{ item.VALUE }}
        </label>
      </div>
    </div>
    <div class="main-checkboxes">
      <p class="necessary-bold">
        <span :class="validPosition() ? 'valid-field' : 'unvalid-field'"
          >➤</span
        >
        Сведения о финансовом положении:
      </p>
      <label v-for="position in positions" :key="position.ID">
        <input
          type="checkbox"
          v-model="position.CHECKED"
          @click="
            onCheckPosition(position);
            checkedValues = [];
            sourceAndRating = '';
            files = [];
            ratingCheckbox = false;
            buhReport = false;
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('IS_STATE_WELL') != -1
          "
        />
        {{ position.VALUE }}
      </label>
    </div>
    <p
      v-if="tableActive(1) || tableActive(0)"
      :class="
        !(
          validFiles() ||
          checkedValues.length > 0 ||
          buhReport ||
          ratingCheckbox
        )
          ? 'necessary-table-not'
          : 'necessary-table'
      "
    >
      Приложите хотя бы один документ или выберите элемент из списка.
    </p>

    <p class="min-one-file" v-if="tableActive(1) || tableActive(0)">
      Вы можете приложить только один файл или архив. Если необходимо приложить
      несколько документов, добавьте документы в архив и прикрепите архив.
    </p>
    <TableFiles
      v-if="tableActive(1)"
      @updateFiles="updateFiles"
      :rowsParent="rows[1]"
    />
    <TableFiles
      v-if="tableActive(0)"
      @updateFiles="updateFiles"
      :rowsParent="rows[0]"
    />
    <table v-if="tableActive(1)">
      <tr
        v-for="item in tableCheckboxes"
        :key="item"
        :class="checkFirstTr(item)"
      >
        <td width="5%">
          <input
            type="checkbox"
            :id="'checkbox-' + tableCheckboxes.indexOf(item)"
            :value="item"
            v-model="checkedValues"
            @click="
              sourceAndRating =
                tableCheckboxes.indexOf(item) == 4 ? '' : sourceAndRating
            "
          />
        </td>
        <td>
          <p>
            <label :for="'checkbox-' + tableCheckboxes.indexOf(item)">{{
              item
            }}</label>
          </p>
        </td>
        <td width="310px" class="last-column"></td>
      </tr>
      <tr v-if="tableActive(1)" class="other-tr">
        <td width="5%">
          <input
            type="checkbox"
            id="rating-checkbox"
            v-model="ratingCheckbox"
            @click="sourceAndRating = ''"
          />
        </td>
        <td>
          <p>
            <label for="rating-checkbox">{{ ratingCaption }}</label>
          </p>
        </td>
        <td width="310px" class="last-column">
          <p v-if="ratingCheckbox">
            <input
              type="text"
              placeholder="Укажите агентство и рейтинг"
              class="input-line"
              v-model="sourceAndRating"
              @input="
                sourceAndRating != null && sourceAndRating > 80
                  ? (sourceAndRating = sourceAndRating.substr(0, 80))
                  : sourceAndRating
              "
            />
          </p>
        </td>
      </tr>
    </table>

    <table v-if="tableActive(0)">
      <tr class="first-tr">
        <td width="5%">
          <input
            type="checkbox"
            id="checkbox-give-buh-report"
            v-model="buhReport"
          />
        </td>
        <td>
          <p>
            <label for="checkbox-give-buh-report"
              >Обязуемся в последующем предоставить копии бухгалтерской
              отчетности с отметками налоговых органов после первой сдачи в
              соответствии с действующим законодательством Российской
              Федерации</label
            >
          </p>
        </td>
        <td width="310px" class="last-column"></td>
      </tr>
    </table>
  </div>
</template>

<script>
import TableFiles from "./parts/v-table-files.vue";
export default {
  name: "FinancialPosition",
  props: {
    pageInfo: {},
    pageName: String,
    isIP: Boolean,
  },
  components: {
    TableFiles,
  },
  data: () => ({
    positions: [],
    finPosition: 0,
    rows: [],
    sendFiles: [],
    checkedValues0: [],
    checkboxes: [],
    selectedId: -1,
    sourceAndRating: "",
    tableCheckboxes: [
      "Ведется производство по делу о несостоятельности (банкротстве) по состоянию на дату представления документов в Банк",
      "Имеются вступившие в силу решения судебных органов о признании несостоятельности (банкротстве) по состоянию на дату представления документов в Банк",
      "Проводится процедура ликвидации по состоянию на дату представления документов в Банк",
      "Имеются факты неисполнения своих денежных обязательств по причине отсутствия денежных средств на банковских счетах",
    ],
    ratingCaption:
      'Данные о рейтинге размещенные в сети "Интернет" на сайтах российских национальных рейтинговых агентств и ' +
      'международных рейтинговых агентств ("Standard & Poor\'s", "Fitch-Ratings", "Moody\'s Investors Service") и другие.',
    ratingCheckbox: false,
    buhReport: false,
    checkedValues: [],
    oneChecked: false,
    sendData: {},
  }),
  methods: {
    updateFiles(files, isMounted) {
      this.sendFiles = files;
      if (!isMounted) this.$emit("updated");
      this.validation();
    },
    onCheck(id) {
      this.checkboxes.forEach((element) => {
        if (element.ID != id) element.CHECKED = false;
      });
      this.selectedId = id;
    },
    validTaxMode() {
      let a = false;
      this.checkboxes.forEach((element) => {
        if (element.CHECKED) a = true;
      });
      return a;
    },
    checkFirstTr(item) {
      if (0 == this.tableCheckboxes.indexOf(item)) return "first-tr";
      else return "other-tr";
    },
    onCheckPosition(pos) {
      this.positions.forEach((item) => {
        this.oneChecked = false;
        if (item.ID != pos.ID) item.CHECKED = false;
      });
      this.oneChecked = pos.CHECKED;
      this.finPosition = pos.ID;
      this.sendFiles = [];
      this.updateRow();
    },
    tableActive(id) {
      if (id == 1) {
        for (let i = 1; i < this.positions.length - 1; i++) {
          if (this.positions[i].CHECKED) return true;
        }
        return false;
      } else {
        return this.positions[5].CHECKED;
      }
    },
    whichTable() {
      this.positions.forEach((item) => {
        if (item.CHECKED) {
          return item.ID != 5;
        }
      });
    },
    validPosition() {
      var checkboxIsOk = false;
      this.positions.forEach((item) => {
        if (item.CHECKED) checkboxIsOk = true;
      });
      return checkboxIsOk;
    },
    validFiles() {
      var fileIsOk = this.positions[0].CHECKED;
      this.sendFiles.forEach(
        (item) => (fileIsOk = fileIsOk || item.FILE != null)
      );
      return fileIsOk;
    },
    validation() {
      var msg = "";
      if (!this.validPosition())
        msg += "Предоставьте сведение о финансовом положении";
      if (
        this.validPosition() &&
        !(
          this.validFiles() ||
          this.checkedValues.length > 0 ||
          this.ratingCheckbox ||
          this.buhReport
        )
      )
        msg += "Приложите хотя бы один документ или выберите элемент из списка";

      if (this.ratingCheckbox && this.sourceAndRating.length == 0)
        msg += "Укажите агенство и рейтинг";
      if (!this.validTaxMode()) msg += "Выберите режим налогообложения";
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        this.sendData.IS_STATE_WELL = this.finPosition;
        var files = this.createFileList();
        if (files != null) this.sendData.FILES = files;
        this.sendData.TAX_MODE_FULL = this.selectedId;
        if (this.tableActive(1)) {
          this.sendData.FINANCE_NEGATIVE_DESCR = this.checkedValues;
          this.sendData.FINANCE_RATING = this.sourceAndRating;
        } else {
          delete this.sendData.FINANCE_NEGATIVE_DESCR;
          delete this.sendData.FINANCE_RATING;
        }
        if (this.tableActive(0))
          this.sendData.SHALL_GIVE_BUH_REPORT = this.buhReport;
        else delete this.sendData.SHALL_GIVE_BUH_REPORT;
        this.$emit("changePageSendData", this.sendData, true);
      }
    },
    updateRow() {
      this.rows = [
        [
          {
            id: 0,
            checkbox: false,
            CAPTION:
              "Копии документов, подтверждающих право владения недвижимым имуществом",
            FILE: null,
          },
          {
            id: 1,
            checkbox: false,
            CAPTION: "Сведения о ценных бумагах, находящихся в собственности",
            FILE: null,
          },
          {
            id: 2,
            checkbox: false,
            CAPTION: "Размер чистых активов",
            FILE: null,
          },
        ],
        [
          {
            id: 0,
            checkbox: false,
            CAPTION:
              "Копия годовой бухгалтерской отчетности (бухгалтерский баланс, отчет о финансовом результате) с отметками налогового органа об их принятии или без такой отметки с приложением либо копии квитанции об отправке заказного письма с описью вложения (при направлении по почте), либо копии подтверждения отправки на бумажных носителях (при передаче в электронном виде)",
            FILE: null,
          },
          {
            id: 1,
            checkbox: false,
            CAPTION:
              "Копия годовой (либо квартальной) налоговой декларации с отметками налогового органа об их принятии или без такой отметки с приложением либо копии квитанции об отправке заказного письма с описью вложения (при направлении по почте), либо копии подтверждения отправки на бумажных носителях (при передаче в электронном виде)",
            FILE: null,
          },
          {
            id: 2,
            checkbox: false,
            CAPTION:
              "Копия аудиторского заключения на годовой отчет за прошедший год, в котором подтверждаются достоверность финансовой (бухгалтерской) отчетности и соответствие порядка ведения бухгалтерского учета законодательству Российской Федерации/международным стандартам финансовой отчетности (МСФО)",
            FILE: null,
          },
          {
            id: 3,
            checkbox: false,
            CAPTION:
              "Справка об исполнении налогоплательщиком (плательщиком сборов, налоговым агентом) обязанности по уплате налогов, сборов, пеней, штрафов, выданная налоговым органом",
            FILE: null,
          },
        ],
      ];
    },
    checkUploadFiles(item) {
      let needToSend = false;
      let isExist = false;
      if (this.pageInfo.FILES != null) {
        this.pageInfo.FILES.forEach((file) => {
          if (file.DESCRIPTION == item.CAPTION) {
            if (item.FILE != null) {
              needToSend = item.FILE.name != file.DS_FILE_NAME;
            } else {
              needToSend = file.DS_FILE_NAME != null;
            }
            isExist = true;
          }
        });
        if (!isExist) needToSend = item.FILE != null;
      } else {
        needToSend = item.FILE != null;
      }
      return needToSend;
    },
    createFileList() {
      let files = [];
      this.sendFiles.forEach((item) => {
        var a = true;
        if (this.pageInfo.FILES != null) {
          this.pageInfo.FILES.forEach((file) => {
            if (
              file.DESCRIPTION == item.CAPTION &&
              item.FILE != null &&
              item.FILE.name == file.DS_FILE_NAME
            ) {
              a = false;
            }
          });
        }
        if (a && item.FILE != null) {
          files.push(item);
        }
      });
      if (this.pageInfo.FILES != null)
        this.pageInfo.FILES.forEach((file) => {
          var a = true;
          this.sendFiles.forEach((item) => {
            if (item.CAPTION == file.DESCRIPTION && item.FILE != null)
              a = false;
          });
          if (a) {
            files.push({ FILE: null, CAPTION: file.DESCRIPTION });
          }
        });
      return files;
    },
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
  async created() {
    this.updateRow();
    try {
      if (this.isIP) {
        this.tableCheckboxes.push(
          "Бухгалтерская отчетность еще не предоставлялась в налоговый орган, гарантируем " +
            "предоставить бухгалтерскую отчетность после первой сдачи в налоговый орган"
        );
      } else {
        this.tableCheckboxes.push(
          "Гарантируем предоставить бухгалтерскую отчетность после первой сдачи в налоговый орган"
        );
      }
      this.sendData.INN = this.pageInfo.INN;

      this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
      this.sendData.ID = this.pageInfo.ID;
      this.checkboxes = this.pageInfo.TAX_MODE_FULL;
      if (this.checkboxes != null)
        this.checkboxes.forEach((item) => {
          if (item.CHECKED) this.selectedId = item.ID;
        });
      if (this.pageInfo.IS_STATE_WELL != null) {
        this.pageInfo.IS_STATE_WELL.sort((a, b) => {
          if (a.ID > b.ID) return 1;
          else if (a.ID == b.ID) return 0;
          else return -1;
        });
        if (this.pageInfo.IS_STATE_WELL != null) {
          this.pageInfo.IS_STATE_WELL.forEach((item) => {
            if (item.CHECKED != null && item.CHECKED)
              this.finPosition = item.ID;
          });
          this.positions = JSON.parse(
            JSON.stringify(this.pageInfo.IS_STATE_WELL)
          );
        }
      } else throw new Error("Ошибка соединения с сервером");
      if (this.pageInfo.FILES != null) {
        var files = this.pageInfo.FILES;
        files.forEach((item) => {
          this.rows[0].forEach((a) => {
            if (a.CAPTION == item.DESCRIPTION) {
              if (item.DS_FILE_NAME != null) {
                a.FILE = { name: item.DS_FILE_NAME };
                a.checkbox = true;
              }
              if (item.DISABLED != null)
                a.DISABLED = item.DISABLED != null && item.DISABLED;
            }
          });
          this.rows[1].forEach((a) => {
            if (a.CAPTION == item.DESCRIPTION) {
              if (item.DS_FILE_NAME != null) {
                a.FILE = { name: item.DS_FILE_NAME };
                a.checkbox = true;
              }
              if (item.DISABLED != null)
                a.DISABLED = item.DISABLED != null && item.DISABLED;
            }
          });
        });
      }
      if (this.pageInfo.FINANCE_NEGATIVE_DESCR != null)
        this.checkedValues = this.pageInfo.FINANCE_NEGATIVE_DESCR;
      if (this.pageInfo.SHALL_GIVE_BUH_REPORT)
        this.buhReport = this.pageInfo.SHALL_GIVE_BUH_REPORT;
      if (this.pageInfo.FINANCE_RATING != null) {
        this.sourceAndRating = this.pageInfo.FINANCE_RATING;
        this.ratingCheckbox = this.sourceAndRating.length > 0;
      }
      this.validation();
    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: justify;
}
.main-checkboxes {
  display: flex;
  flex-direction: column;
}
label {
  margin-bottom: 5px;
}
.necessary {
  color: red;
}
.min-one-file {
  text-align: center;
  font-size: 12px;
}
.input-line {
  border: none;
  border-bottom: 1px solid #cccccc;
  width: 280px;
  position: relative;
}
.input-line:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
table {
  border-collapse: collapse;
  border-top: 0px solid black;
  width: 100%;
}
.last-column {
  border-left: 1px solid black;
}
.first-tr {
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
}
.other-tr {
  border: 1px solid black;
}
td {
  padding: 0px 10px;
}
</style>
